import { NgModule } from '@angular/core';
import { SaysuaCommonModule } from '../../common.module';
import { AuthModule } from '../../shared/auth/auth.module';

import { LoginComponent } from './login.component';

@NgModule({
    imports: [
        SaysuaCommonModule,
        AuthModule
    ],
    exports: [],
    declarations: [LoginComponent],
    providers: [],
})
export class LoginModule { }
